import { createFileRoute } from '@tanstack/react-router';
import { AcessoNegado } from '@/features/login/page/AcessoNegado';

export const Route = createFileRoute('/auth/acesso-negado')({
    component: AcessoNegado,
});
